export default {
  "messageBox": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["メッセージボックス"])},
  "more": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["すべて表示"])},
  "noMessage": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["メッセージはありません"])},
  "list": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["メッセージ一覧"])}
}